import type { IconName } from "@salestrak/ui";

/** Property labels share these glyphs across summaries, cards, and view controls.
 * Entity values keep their own icons, avatars, and stage indicators. The
 * glyphs are the plain app-surface outlines: a property label is a control's
 * caption, not an identity, so it wears no heavier variant. */
export const PROPERTY_ICON = {
  issueType: "package",
  workflow: "workflow",
  stage: "circle-circle",
  assignee: "circle-user",
  team: "users",
  issueSource: "square-arrow-enter-right",
  address: "map-pin",
  company: "apartment",
  phone: "phone",
  website: "globe",
  billing: "credit-card",
  created: "calendar",
  updated: "calendar-clock",
  /** The follow-up clock: the one glyph for age, cycle and update status. */
  followUp: "heart-pulse",
} as const satisfies Record<string, IconName>;
